// git push -u origin main
import React, { useState } from 'react';
import BikeImage1 from '../../../assets/BikeImage1.png';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ButtonMoreDetails = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(0);
    };
    // State to handle modal visibility
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExchangeModalOpen, setIsExchangeModalOpen] = useState(false);
    // Function to toggle modal visibility
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleExchangeModal = () => {
        setIsExchangeModalOpen(!isExchangeModalOpen);
    };

    return (
        <>
            <div className="w-full bg-[#FF9630] text-white  py-4 px-6 flex  items-center">
                <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
                    <FaArrowLeft className="text-lg" />
                </button>
                <h1 className="text-xl font-semibold">My Bookings</h1>
            </div>
            <div className="flex justify-center items-center overflow-auto border rounded-lg bg-gray-100 w-full">
                <div className="w-full bg-white min-h-screen  rounded-lg p-8">
                    <div className="flex justify-center mb-2">
                        <img src={BikeImage1} alt="Hero Glamour Xtec 125 N" className="h-32" />
                    </div>
                    <div className="text-center font-semibold text-lg">Hero Glamour Xtec 125 N</div>

                    {/* Date and Time Section */}
                    <div className="flex justify-between items-center text-gray-700 mt-4 mb-6">
                        <div className="text-center">
                            <p className="text-sm">03:30 pm</p>
                            <p className="text-xs">10 Oct 2024</p>
                        </div>
                        <p className="text-sm font-semibold ">to</p>
                        <div className="text-center">
                            <p className="text-sm">08:30 am</p>
                            <p className="text-xs">17 Oct 2024</p>
                        </div>
                    </div>

                    {/* Ride Details Grid with Borders */}
                    <p className="font-medium text-left">Details:</p>
                    <div className="grid grid-cols-2 gap-y-1 text-sm text-gray-700">
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">Location</p>
                                <p className="text-right">Camp Belagovi</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">Vehicle Number</p>
                                <p className="text-right">KA22HZ211</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">Hero Glamour Xtec 125 N</p>
                                <p className="text-right">₹450.00</p>
                            </div>
                        </div>

                        {/* Accessories Section */}
                        <p className="font-medium text-left">Accessories:</p>
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">2 Regular Helmet</p>
                                <p className="text-right">₹200.00</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">2 Regular Jacket</p>
                                <p className="text-right">₹100.00</p>
                            </div>
                        </div>

                        {/* Wallet Section */}
                        <p className="font-medium text-left">Wallet:</p>
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">Wallet Deduction</p>
                                <p className="text-right">₹50.00</p>
                            </div>
                        </div>

                        {/* Insurance Section */}
                        <p className="font-medium text-left">Insurance:</p>
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">MoveronWheels Insurance</p>
                                <p className="text-right">₹12.00/3hr</p>
                            </div>
                        </div>

                        {/* Coupon Section */}
                        <p className="font-medium text-left">Coupon:</p>
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">Applied Coupon</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                        </div>

                        <p className="font-medium text-left">Total Amount:</p>
                        <div className="col-span-2 border border-gray-300 rounded-md p-2 mb-2">
                            <div className="flex justify-between">
                                <p className="text-left">CGST(0%)</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">SGST(0%)</p>
                                <p className="text-right">₹0.00</p>
                            </div>
                            <div className="flex justify-between">
                                <p className="text-left">Total Amount</p>
                                <p className="text-right">₹862.00</p>
                            </div>
                            <div>
                            </div>
                        </div>

                        <div className="col-span-2 border border-[#FF9630] text-[#FF9630] rounded-md p-2 mb-2">
                            <div className="flex justify-center">
                                <p className="text-left text-md ">CONTACT PARTNER</p>

                            </div>
                        </div>

                        <div className="col-span-2 border border-[#FF9630] text-[#FF9630] rounded-md p-2 mb-2">
                            <div className="flex justify-center">
                                <button onClick={toggleExchangeModal} className="text-left">EXCHANGE RIDE</button>
                            </div>
                        </div>

                        <div className="col-span-2 border border-[#FF9630] text-[#FF9630] rounded-md p-2 mb-2">
                            <div className="flex justify-center">
                                <button onClick={toggleModal} className="text-left">CANCEL RIDE</button>
                            </div>
                        </div>
                    </div>
                    {isModalOpen && (
                        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                            <div
                                className="bg-white rounded-lg w-full max-w-6xl min-h-screen overflow-y-auto"
                                style={{ height: "90vh" }} // Adjust modal height dynamically
                            >
                                {/* Modal Header */}
                                <div className="bg-[#FF9630] rounded-t-lg py-2">
                                    <h2 className="text-2xl font-semibold text-white text-center">Cancel</h2>
                                </div>

                                {/* Modal Content */}
                                <div className="bg-orange-100 p-3 text-[#FF9630] rounded-md text-lg mb-4">
                                    <h3 className="font-semibold">Cancellation & Refund Terms</h3>
                                    <ul className="list-disc ml-4 text-base mt-1 text-left">
                                        <li>Less than 48hrs before the scheduled date of Hire -- No refund</li>
                                        <li>More than 48hrs before the scheduled date of Hire -- 25%-50% refund depending on bike.</li>
                                        <li>Cancellations made within 24 hours of booking will have no additional charges.</li>
                                        <li>If the bike is not returned on time, a late fee will apply. Refunds will be processed according to cancellation Policy</li>
                                    </ul>
                                </div>

                                {/* Refund Details */}
                                <div className="p-4">
                                    <div className="p-3 rounded-md border mb-4">
                                        <p className="text-left font-semibold text-[#FF9630]">Refund Amount</p>
                                        <div className="p-3 rounded-md border m-5">
                                            <p className="flex justify-between font-semibold">
                                                <span>Total Amount</span>
                                                <span>₹862.00</span>
                                            </p>
                                            <p className="flex justify-between font-semibold">
                                                <span>Total Refund Amount</span>
                                                <span>₹562.00</span>
                                            </p>
                                            <p className="flex justify-between">
                                                <span>Total Amount Paid</span>
                                                <span>-₹62.00</span>
                                            </p>
                                            <p className="flex justify-between">
                                                <span>Convenience Fees</span>
                                                <span>-₹20.00</span>
                                            </p>
                                            <p className="flex justify-between">
                                                <span>Cancellation Fees</span>
                                                <span>-₹362.00</span>
                                            </p>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="flex justify-around">
                                        <button
                                            onClick={toggleModal}
                                            className="bg-gray-200 text-gray-700 py-2 px-4 w-1/3 rounded-lg"
                                        >
                                            DISCARD
                                        </button>
                                        <button
                                            onClick={() => alert("Proceeding with cancellation...")}
                                            className="bg-[#FF9630] w-1/3 text-white py-1 px-4 rounded-lg"
                                        >
                                            PROCEED
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {isExchangeModalOpen && (
                        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                            {/* Modal Content */}
                            <div className="bg-white rounded-lg w-full max-w-6xl max-h-screen overflow-y-auto" style={{ height: '100vh' }}>
                                <div className="bg-[#FF9630] rounded-t-lg py-2">
                                    <h2 className="text-2xl font-semibold text-white text-center">Exchange</h2>
                                </div>

                                <div className="bg-orange-100 p-3 text-[#FF9630] rounded-md text-lg mb-4">
                                    <h3 className="font-semibold">Exchange Policy</h3>
                                    <p>If you exchange the booking, the refund would be made as per the following schedule:</p>
                                    <ul className="list-disc ml-4 text-base mt-1 text-left">
                                        <li>Less than 48hrs before the scheduled date of Hire -- No refund</li>
                                        <li>More than 48hrs before the scheduled date of Hire -- 25%-50% refund depending on the bike.</li>
                                    </ul>
                                </div>

                                {/* Refund Details */}
                                <div className="p-4">
                                    <div className="p-3 rounded-md border mb-4">
                                        <p className="text-left font-semibold text-[#FF9630]">Exchange Details</p>
                                        <div className="p-3 rounded-md border m-5">
                                            <p className="flex justify-between font-semibold">
                                                <span>Total Amount</span>
                                                <span>₹700.00</span>
                                            </p>
                                            <p className="flex justify-between font-semibold">
                                                <span>Total Refund Amount</span>
                                                <span>₹678.00</span>
                                            </p>
                                            <p className="flex justify-between">
                                                <span>Convenience Fees</span>
                                                <span>-₹20.00</span>
                                            </p>
                                            <p className="flex justify-between">
                                                <span>Cancellation Fees</span>
                                                <span>-₹12.00</span>
                                            </p>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="flex justify-around">
                                        <button onClick={toggleExchangeModal} className="bg-gray-200 text-gray-700 py-2 px-4 w-1/3 rounded-lg">
                                            DISCARD
                                        </button>
                                        <button onClick={() => alert('Proceeding with exchange...')} className="bg-[#FF9630] w-1/3 text-white py-1 px-4 rounded-lg">
                                            PROCEED
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ButtonMoreDetails;